import { createRouter, createWebHistory } from 'vue-router'

import LineHome from '../views/LineHome.vue'
import ProductList from '../views/LineProducts.vue'
import ProductDetails from '../views/LineProductDetails.vue'
import Partnerzy from '../views/LinePartnerzy.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: LineHome
  },
  {
    path: '/produkty',
    name: 'ProductList',
    component: ProductList
  },
  {
    path: '/partnerzy',
    name: 'Partnerzy',
    component: Partnerzy
  },
  {
    path: '/produkty/:sku',
    name: 'ProductDetails',
    component: ProductDetails
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
